import {Injectable} from '@angular/core';
import {InsolesUserSummaryModel} from './insolesUserSummary.model';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';

@Injectable()
export class InsolesUserSummaryConverter extends HttpModelConverter<InsolesUserSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): InsolesUserSummaryModel {
        return new InsolesUserSummaryModel();
    }

    protected enrichObject(result: InsolesUserSummaryModel, src: InsolesUserSummaryModel) {
    }

}
